import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const TnCContainer = ({ isMobile }) => {
    const { t } = useTranslation(['luckyWheel']);
    const [expandedSection, setExpandedSection] = useState(null);

    const toggleSection = (section) => {
        setExpandedSection(expandedSection === section ? null : section);
    };

    return (
        <div className='tnc-container'>
            <header>
                <h2>{t('luckyWheel.tncTitle', 'Terms & Conditions')}</h2>
            </header>

            {/* Lucky Wheel Spin Section */}
            <section id='luckyWheelSpin'>
                <h2>{t('luckyWheel.luckyWheelSpin')}</h2>
            </section>

            {/* Event Details Section */}
            <section id='eventDetails'>
                <div className='collapsible-header' onClick={() => toggleSection('eventDetails')}>
                    <h4>{t('luckyWheel.eventDetails')}</h4>
                    <LazyLoadImage
                        src='/public/html/images/lucky-wheel/accordion.svg'
                        alt='accordion'
                        className={expandedSection === 'eventDetails' ? 'expanded' : 'collapsed'}
                    />
                </div>
                {(expandedSection === 'eventDetails' || !isMobile) && (
                    <div className='collapsible-content'>
                        <p>{t('luckyWheel.eventDetails1')}</p>
                        <p>{t('luckyWheel.eventDetails2')}</p>
                        <p>{t('luckyWheel.eventDetails3')}</p>
                    </div>
                )}
            </section>

            {/* Terms and Conditions Section */}
            <section id='tnc'>
                <div className='collapsible-header' onClick={() => toggleSection('tnc')}>
                    <h4>{t('luckyWheel.tncTitle2')}</h4>
                    <LazyLoadImage src='/public/html/images/lucky-wheel/accordion.svg' alt='accordion' className={expandedSection === 'tnc' ? 'expanded' : 'collapsed'} />
                </div>
                {(expandedSection === 'tnc' || !isMobile) && (
                    <div className='collapsible-content'>
                        {[...Array(10).keys()].map((i) => (
                            <p key={`tnc-${i + 1}`}>{t(`luckyWheel.tnc${i + 1}`)}</p>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default TnCContainer;
